<template>
  <b-tab class="lot-overview-tab w-100">
    <template v-slot:title>
      {{ $t('Lot Overview') }}
    </template>
    <div class="outer-container pt-2 pr-2">
      <active-lot-details :active-lot="activeLot" :sale-info="saleInfo"/>
    </div>
  </b-tab>
</template>

<script>
  import ActiveLotDetails from "@/modules/live-bids/ActiveLotDetails";

  export default {
    name: "LotOverviewTab",
    components: {ActiveLotDetails},
    props: {
      activeLot: {
        type: Object,
        required: true
      },
      saleInfo: {
        type: Object,
        required: true
      }
    },
  }
</script>

<style lang="scss" scoped>
  .lot-overview-tab {
    display: flex;
    height: 100%;
  }

  .outer-container {
    flex: 1;
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>